import FooterMethodsList from './FooterMethodsList';

export default FooterMethodsList;